import { useEventStream } from '@/Components/Hooks/useEventStream';
import {
  BIOMETRIC_SSE_EVENTS,
  ENGAGEMENT_BUNDLE_SSE_EVENTS,
  SENSOR_SSE_EVENTS,
} from '@/constants/device';
import { useMemo } from 'react';
import { CATEGORIES, getSupportedAlertEventTypesForCategory } from './utils';

export const useDashboardEventStream = ({ useruuid, supportedCategories, isConfigLoading }) => {
  const supportedAlertEventTypes = useMemo(
    () => getSupportedAlertEventTypesForCategory(supportedCategories),
    [supportedCategories]
  );

  const recentActivitySseEvents = useMemo(
    () => [
      ...(supportedCategories.includes(CATEGORIES.SMART_HOME) ? SENSOR_SSE_EVENTS : []),
      ...(supportedCategories.includes(CATEGORIES.BIOMETRIC) ? BIOMETRIC_SSE_EVENTS : []),
      ...ENGAGEMENT_BUNDLE_SSE_EVENTS,
    ],
    [supportedCategories]
  );

  const { latestEvent, eventStream } = useEventStream(
    { useruuid },
    [...supportedAlertEventTypes, ...recentActivitySseEvents],
    undefined,
    { enabled: !isConfigLoading }
  );

  return { latestEvent, eventStream };
};
